const ja: Record<string, Record<string, string>> = {
  playerControls: {
    mute: 'ミュート',
    unmute: 'ミュート解除',
    play: '遊びます',
    pause: '休止'
  },
  errors: {
    noVideoId: 'ビデオは提供されていません',
    noVideoDescription: 'これが表示された場合は、プラットフォームサポートにお問い合わせください。',
  }
}

export default ja;